import { InjectionToken, Provider } from '@angular/core';
import { PMOrderOperation } from 'src/app/models/domain';
import { PagedCollection } from 'src/app/state';

export const PM_OPERATION_PAGINATOR = new InjectionToken<PagedCollection<PMOrderOperation>>(
  'PM_OPERATION_PAGINATOR'
);

/**
 * Per-component, not `providedIn: 'root'`. Two components share this token — planning-report
 * and development-milestones-frontend-table — and for the `Reorder` role they render in the
 * same tab, so a root-provided instance meant one page cache and one `pageChanges` subject
 * between them: paging one table moved the other. Listing this in a component's `providers`
 * gives each its own.
 */
export const providePmOperationPaginator = (): Provider => ({
  provide: PM_OPERATION_PAGINATOR,
  useFactory: () => new PagedCollection<PMOrderOperation>(),
});
